var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainBox" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "气象", name: "first" } },
            [_vm.activeName === "first" ? _c("qx") : _vm._e()],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "墒情", name: "second" } },
            [_vm.activeName === "second" ? _c("sq") : _vm._e()],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "视频", name: "third" } },
            [_vm.activeName === "third" ? _c("nq") : _vm._e()],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }